import { Breadcrumbs, Icon, styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

const BreadcrumbRoot = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& a': {
    textDecoration: 'none',
  },
}));

const SubName = styled('span')(({ theme }) => ({
  textTransform: 'capitalize',
  color: '#8a869f',
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: 1,
}));

const StyledIcon = styled(Icon)(() => ({
  marginLeft: 0,
  marginBottom: 0,
  marginRight: 6,
  fontSize: '17px',
  verticalAlign: 'middle',
}));

const Breadcrumb = ({ routeSegments }) => {
  return (
    <BreadcrumbRoot>
      <Breadcrumbs
        separator={<Icon sx={{ color: '#8a869f', fontSize: '17px' }}>navigate_next</Icon>}
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          '& .MuiBreadcrumbs-ol': {
            gap: 0,
            alignItems: 'center',
          },
          '& .MuiBreadcrumbs-separator': {
            mx: '4px',
          },
          '& .MuiBreadcrumbs-li:first-of-type + .MuiBreadcrumbs-separator': {
            display: 'none',
            m: 0,
          },
        }}
      >
        <NavLink to="/">
          <StyledIcon color="primary">home</StyledIcon>
        </NavLink>

        {routeSegments
          ? routeSegments.map((route, index) => {
              return index !== routeSegments.length - 1 ? (
                <NavLink key={index} to={route.path}>
                  <SubName>{route.name}</SubName>
                </NavLink>
              ) : (
                <SubName key={index}>{route.name}</SubName>
              );
            })
          : null}
      </Breadcrumbs>
    </BreadcrumbRoot>
  );
};

export default Breadcrumb;
